<div class="container">
    <div class="row" *ngIf="!passwordSent">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <form [formGroup]="emailForm" class="" (ngSubmit)="onSubmit()">
                <h1>Olvido su contrase&ntilde;a?</h1>
                <p style="color: white;">Ingrese su direcci&oacute;n correo electr&oacute;nico para obtener una una contrase&ntilde;a
                    temporal. En breve recibir&aacute; un mensaje de nuestro equipo de soporte.</p>
                <div class="form-group">
                    <input type="text" formControlName="mailAddress" class="form-control"
                        placeholder="Ingrese su correo electronico"
                        [ngClass]="{'is-invalid': submitted && f['mailAddress'].errors }" />
                    <div *ngIf="submitted && f['mailAddress'].errors" class="invalid-feedback">
                        <div *ngIf="f['mailAddress'].errors['required']">El correo es requerido.</div>
                    </div>
                    <div *ngIf="submitted && f['mailAddress'].errors" class="invalid-feedback">
                        <div *ngIf="f['mailAddress'].errors['email']">Formato de correo inv&aacute;lido.</div>
                    </div>
                </div>
                <div class="form-group">
                    <button class="btn btn-primary btn-block" type="submit">Enviar</button>
                    <button class="btn btn-secondary btn-block" (click)="onCancel();">Cancelar</button>
                </div>
            </form>
        </div>
        <div class="col-lg-3"></div>
    </div>
    <div class="row" *ngIf="passwordSent">
        <div class="col-lg-3"></div>
        <div class="col-lg-6" class="text-center formClass boxed">
            <p>Hemos enviado un mensaje con una contrase&ntilde;a temporal al correo que ha proporcionado.
                Por favor ingrese a la aplicaci&oacute;n haciendo uso de este contrase&ntilde;a y proceda a
                actualizarla.</p>
            <button class="btn btn-primary" (click)="onCancel();">Ingresar</button>
        </div>
        <div class="col-lg-3"></div>
    </div>
</div>
<p-toast [style]="{marginTop: '100px'}" position="top-center" key="tc" [hideTransitionOptions]="'1ms'">
</p-toast>